import {Preferences} from '../models/preferences.model';

export class CoreState {
  public preferences: Preferences;
}
